export default "__VITE_ASSET__DlMIBf0n__"